<div [ngClass]="[styles.progressWrapper, mini ? styles.mini : '']">
	<div [ngClass]="styles.progressContainer">
		<div uiControl class="theme-progress-bar theme-primary-txt theme-accent-bg" role="progressbar" [attr.aria-label]="label" [attr.aria-valuenow]="progress" [attr.aria-valuemin]="0" [attr.aria-valuemax]="max" [ngClass]="styles.progressBar" [ngStyle]="{ width: progressPercentage + '%' }">
		</div>
	</div>

	<span [ngClass]="styles.progressMetaData" *ngIf="label">
			{{ label }}
	</span>

	<span [ngClass]="styles.progressMetaData">
			{{ progressPercentage | number: '1.0-0' }}%
			<span *ngIf="!mini">{{ 'Complete' | translate }}</span>
	</span>
</div>
